module.exports = __webpack_public_path__ + "static/media/estore-banner.af1a8a90.jpg";